import { combineReducers } from "redux"
import MasterReducer from "./MasterReducer";
import EmployeeReducer from "./Admin/EmployeeReducer";
import EmployeeMasterReducer from "./Admin/EmployeeMasterReducer";
import RolePermissionReducer from "./Admin/RolePermissionReducer";
import PickedRateRequestReducer from "./Sales/PickedRateRequestReducer";
import NavbarReducer from "./NavbarReducer";
import QuoteAirExportCompGenInfoReducer from "./Sales/QuoteAirExportCompGenInfoReducer";
import LeadStatusReducer from "./Sales/LeadStatusReducer";
import CustomerReducer from "./Admin/CustomerReducer";
import PricingLeadStatusReducer from "./Pricing/PricingLeadStatusReducer";
import LoginMasterReducer from "./HRMS/Login/LoginMasterReducer";
import OrganisationListReducer from "./Organisation/OrganisationListReducer";
import BranchReducer from "./Organisation/Branch/BranchReducer";
import JoborderReducer from "./JobOrder/JoborderReducer";
import CCReducer from "./CustomClerance/CCReducer";
import CCImportReducer from "./CustomClerance/CCImportReducer";
import FFAirExpReducer from "./FreightForwarding/Console/FFAirExpReducer";
import FFSeaExpReducer from "./FreightForwarding/Sea/FFSeaExpReducer";
import TransportReducer from "./Transport/TransportReducer";
import OperationExpenseReducer from "./OperationExpense/OperationExpenseReducer";
import FFAirImpReducer from "./FreightForwarding/Console/FFAirImpReducer";
import FFSeaImpReducer from "./FreightForwarding/Sea/FFSeaImpReducer";
import AccountReducer from "./Account/AccountReducer";
import CustomerPanelReducer from "./Customer/CustomerPanelReducer";

const rootReducer = combineReducers({
    MasterReducer,
    EmployeeReducer,
    EmployeeMasterReducer,
    RolePermissionReducer,
    PickedRateRequestReducer,
    NavbarReducer,
    QuoteAirExportCompGenInfoReducer,
    LeadStatusReducer,
    CustomerReducer,
    PricingLeadStatusReducer,
    LoginMasterReducer,
    OrganisationListReducer,
    BranchReducer,
    JoborderReducer,
    CCReducer,
    CCImportReducer,
    FFAirExpReducer,
    FFAirImpReducer,
    FFSeaExpReducer,
    FFSeaImpReducer,
    TransportReducer,
    OperationExpenseReducer,
    AccountReducer,
    CustomerPanelReducer
});

export default rootReducer;